<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permission.device_service_export !== false"
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>
      <template slot="maintenanceType" slot-scope="{ row }">
        <el-tag v-if="row.maintenanceType === 'routine'" type="info" size="small">日常维保</el-tag>
        <el-tag v-else-if="row.maintenanceType === 'periodic'" type="primary" size="small">定期维保</el-tag>
        <el-tag v-else-if="row.maintenanceType === 'seasonal'" type="warning" size="small">季节性维保</el-tag>
        <el-tag v-else size="small">{{ row.maintenanceType }}</el-tag>
      </template>

      <template slot="planDate" slot-scope="{ row }">
        {{ formatDate(row.planDate) }}
      </template>
      <template slot="deadline" slot-scope="{ row }">
        {{ formatDate(row.deadline) }}
      </template>

      <template slot="startTime" slot-scope="{ row }">
        {{ formatDateTime(row.startTime) }}
      </template>
      <template slot="endTime" slot-scope="{ row }">
        {{ formatDateTime(row.endTime) }}
      </template>
      <template slot="workHoursCalc" slot-scope="{ row }">
        {{ calcMaintenanceWorkHours(row.startTime, row.endTime) }}
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleDetail(row)">维护报告</el-button>
      </template>
    </avue-crud>

    <el-dialog title="设备维保记录详情" :visible.sync="detailDialogVisible" width="900px" top="6vh" :append-to-body="true">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="计划编号">{{ detailData.planNo }}</el-descriptions-item>
        <el-descriptions-item label="维保类型">
          <el-tag v-if="detailData.maintenanceType === 'routine'" type="info" size="small">日常维保</el-tag>
          <el-tag v-else-if="detailData.maintenanceType === 'periodic'" type="primary" size="small">定期维保</el-tag>
          <el-tag v-else-if="detailData.maintenanceType === 'seasonal'" type="warning" size="small">季节性维保</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="设备名称">{{ detailData.deviceName }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag v-if="detailData.status === 0" type="info" size="small">待执行</el-tag>
          <el-tag v-else-if="detailData.status === 1" type="primary" size="small">执行中</el-tag>
          <el-tag v-else-if="detailData.status === 2" type="success" size="small">已完成</el-tag>
          <el-tag v-else-if="detailData.status === 3" type="warning" size="small">已延期</el-tag>
          <el-tag v-else-if="detailData.status === 4" type="warning" size="small">待审核</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="计划日期">{{ formatDate(detailData.planDate) }}</el-descriptions-item>
        <el-descriptions-item label="截止日期">{{ formatDate(detailData.deadline) }}</el-descriptions-item>
        <el-descriptions-item label="执行人">{{ detailData.executorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ formatDateTime(detailData.startTime) }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ formatDateTime(detailData.endTime) }}</el-descriptions-item>
        <el-descriptions-item label="维保结果" :span="2">{{ detailData.result || '-' }}</el-descriptions-item>
        <el-descriptions-item label="维保内容" :span="2">{{ detailData.content || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div class="detail-photo-section">
        <div class="detail-photo-title">维保照片</div>
        <div v-if="maintenancePhotoList(detailData).length" class="detail-photo-list">
          <el-image
            v-for="(url, index) in maintenancePhotoList(detailData)"
            :key="url + index"
            class="detail-photo"
            :src="url"
            fit="cover"
            :preview-src-list="maintenancePhotoList(detailData)"
          />
        </div>
        <div v-else class="detail-photo-empty">暂无维保照片</div>
      </div>

      <div class="detail-apply-section">
        <div class="detail-apply-title">备件领用申请</div>
        <el-table v-loading="planApplyLoading" :data="planApplyList" border size="small" class="detail-apply-master-table" max-height="360">
          <el-table-column type="expand">
            <template slot-scope="{ row: parent }">
              <div class="detail-apply-expand">
                <div class="detail-apply-expand-label">备件明细</div>
                <el-table
                  v-if="(parent.detailList || []).length"
                  :data="parent.detailList"
                  border
                  size="mini"
                  class="detail-apply-inner-table"
                >
                  <el-table-column prop="partCode" label="备件编码" min-width="110" show-overflow-tooltip />
                  <el-table-column prop="partName" label="备件名称" min-width="120" show-overflow-tooltip />
                  <el-table-column prop="specification" label="规格型号" min-width="100" show-overflow-tooltip />
                  <el-table-column label="需归还" width="72" align="center">
                    <template slot-scope="{ row: line }">{{ detailNeedReturnYesNo(line) }}</template>
                  </el-table-column>
                  <el-table-column label="归还状态" width="100" align="center">
                    <template slot-scope="{ row: line }">{{ detailReturnStatusLabel(parent, line) }}</template>
                  </el-table-column>
                  <el-table-column prop="requestQty" label="申请数量" width="88" align="center" />
                  <el-table-column prop="currentStock" label="当前库存" width="88" align="center" />
                  <el-table-column prop="remark" label="备注" min-width="80" show-overflow-tooltip />
                </el-table>
                <div v-else class="detail-apply-inner-empty">暂无明细</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="requestNo" label="申请单号" min-width="150" show-overflow-tooltip />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{ row: r }">
              <el-tag v-if="r.status === 0" type="warning" size="mini">待审批</el-tag>
              <el-tag v-else-if="r.status === 1" type="primary" size="mini">待归还</el-tag>
              <el-tag v-else-if="r.status === 2" type="success" size="mini">已完成</el-tag>
              <el-tag v-else-if="r.status === 3" type="danger" size="mini">已拒绝</el-tag>
              <el-tag v-else type="info" size="mini">-</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="需归还" width="72" align="center">
            <template slot-scope="{ row: r }">{{ applyNeedReturnYesNo(r) }}</template>
          </el-table-column>
          <el-table-column label="归还备件数" width="92" align="center">
            <template slot-scope="{ row: r }">{{ applyReturnSpareQtyText(r) }}</template>
          </el-table-column>
          <el-table-column label="归还状态" width="100" align="center">
            <template slot-scope="{ row: r }">{{ applyReturnStatusLabel(r) }}</template>
          </el-table-column>
          <el-table-column prop="partKindCount" label="种类数" width="72" align="center" />
          <el-table-column prop="totalRequestQty" label="总数量" width="88" align="center" />
          <el-table-column prop="applicantName" label="申请人" width="100" show-overflow-tooltip />
          <el-table-column label="申请时间" min-width="155">
            <template slot-scope="{ row: r }">{{ formatDateTime(r.requestTime) }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { mapGetters } from 'vuex'
import { getList, exportMaintenancePlanExcel } from '../device-maintenance/api'
import { downloadXls } from '@/util/util'
import { listApplyByMaintenancePlan } from '../part-request/api'

export default {
  name: 'system-device-service',
  mixins: [crudMixins],
  data() {
    return {
      exportLoading: false,
      apiConfig: { getList },
      /** 固定仅查询已完成维保计划 */
      defaultParams: {
        status: 2,
      },
      detailDialogVisible: false,
      detailData: {},
      planApplyList: [],
      planApplyLoading: false,
      option: {
        ...this.$store.state.publicOption,
        searchMenuSpanSuper: 21,
        searchMenuPosition: 'right',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 100,
        stripe: true,
        column: [
          {
            label: '计划编号',
            prop: 'planNoSearch',
            type: 'input',
            search: true,
            hide: true,
            searchPlaceholder: '计划编号',
            searchSpan: 6,
          },
          {
            label: '设备名称',
            prop: 'deviceNameSearch',
            type: 'input',
            search: true,
            hide: true,
            searchPlaceholder: '设备名称',
            searchSpan: 6,
          },
          {
            label: '计划日期',
            prop: 'planDateRange',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            search: true,
            searchRange: true,
            hide: true,
            searchSpan: 9,
            paramsKey: ['startDate', 'endDate'],
          },
          {
            label: '计划编号',
            prop: 'planNo',
            width: 160,
            align: 'center',
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            minWidth: 150,
            align: 'center',
            overHidden: true,
          },
          {
            label: '维保类型',
            prop: 'maintenanceType',
            width: 100,
            align: 'center',
            slot: true,
          },
          {
            label: '计划日期',
            prop: 'planDate',
            width: 110,
            align: 'center',
            slot: true,
          },
          {
            label: '截止日期',
            prop: 'deadline',
            width: 110,
            align: 'center',
            slot: true,
          },
          {
            label: '执行人',
            prop: 'executorName',
            width: 100,
            align: 'center',
          },
          {
            label: '开始时间',
            prop: 'startTime',
            width: 158,
            align: 'center',
            slot: true,
          },
          {
            label: '结束时间',
            prop: 'endTime',
            width: 158,
            align: 'center',
            slot: true,
          },
          {
            label: '维保工时(小时)',
            prop: 'workHoursCalc',
            width: 118,
            align: 'center',
            slot: true,
          },
          {
            label: '维保内容',
            prop: 'content',
            minWidth: 150,
            align: 'center',
            overHidden: true,
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['permission']),
  },
  methods: {
    formatParams(params) {
      const result = crudMixins.methods.formatParams.call(this, params)
      if (result.planNoSearch) result.planNo = result.planNoSearch
      if (result.deviceNameSearch) result.deviceName = result.deviceNameSearch
      delete result.planNoSearch
      delete result.deviceNameSearch
      return result
    },
    /**
     * 导出当前筛选条件下的列表为 Excel（服务端生成，列与表格一致）。
     */
    async handleExport() {
      const total = this.page.total || 0
      if (total < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      const maxRows = 10000
      if (total > maxRows) {
        this.$message.warning(`当前最多导出 ${maxRows} 条，请缩小筛选范围后重试`)
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportMaintenancePlanExcel(params)
        downloadXls(res.data, `设备维保服务_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    handleDetail(row) {
      this.detailData = { ...row }
      this.detailDialogVisible = true
      this.loadPlanSpareApplies(row.id)
    },
    applyMasterNeedsReturn(row) {
      return row && (row.needReturn === 1 || row.needReturn === '1')
    },
    applyNeedReturnYesNo(row) {
      return this.applyMasterNeedsReturn(row) ? '是' : '否'
    },
    applyReturnSpareQtyText(row) {
      if (!this.applyMasterNeedsReturn(row)) return '—'
      const q = row.returnSpareQty
      if (q == null || q === '') return '0'
      return String(q)
    },
    applyReturnStatusLabel(row) {
      if (!row || !this.applyMasterNeedsReturn(row)) return '无需归还'
      const s = row.status
      if (s === 0 || s === '0') return '待审批'
      if (s === 1 || s === '1') return '待归还'
      if (s === 2 || s === '2') return '已归还'
      if (s === 3 || s === '3') return '已拒绝'
      return '—'
    },
    detailLineNeedsReturn(line) {
      if (!line) return false
      if (line.needReturn === 1 || line.needReturn === '1') return true
      return Number(line.partType) === 2
    },
    detailNeedReturnYesNo(line) {
      return this.detailLineNeedsReturn(line) ? '是' : '否'
    },
    detailReturnStatusLabel(parent, line) {
      if (!this.detailLineNeedsReturn(line)) return '无需归还'
      return this.applyReturnStatusLabel(parent)
    },
    maintenancePhotoList(row) {
      const raw = row && row.maintenancePhotos
      if (!raw) return []
      if (Array.isArray(raw)) {
        return raw.map((item) => String(item || '').trim()).filter(Boolean)
      }
      const text = String(raw).trim()
      if (!text) return []
      if (text.charAt(0) === '[') {
        try {
          const arr = JSON.parse(text)
          if (Array.isArray(arr)) {
            return arr.map((item) => String(item || '').trim()).filter(Boolean)
          }
        } catch (e) {
          /* 兼容逗号分隔格式 */
        }
      }
      return text.split(',').map((item) => item.trim()).filter(Boolean)
    },
    loadPlanSpareApplies(planId) {
      this.planApplyList = []
      if (planId == null || planId === '') {
        this.planApplyLoading = false
        return
      }
      this.planApplyLoading = true
      listApplyByMaintenancePlan(planId)
        .then((res) => {
          const body = res && res.data
          const list = body && body.data
          this.planApplyList = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.planApplyList = []
        })
        .finally(() => {
          this.planApplyLoading = false
        })
    },
    formatDate(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      const date = new Date(val)
      const year = date.getFullYear()
      const month = (`0${date.getMonth() + 1}`).slice(-2)
      const day = (`0${date.getDate()}`).slice(-2)
      return `${year}-${month}-${day}`
    },
    /**
     * 根据开始、结束时间计算维保工时（小时），保留两位小数。
     */
    calcMaintenanceWorkHours(startTime, endTime) {
      if (startTime == null || startTime === '' || endTime == null || endTime === '') {
        return '-'
      }
      const startMs = new Date(startTime).getTime()
      const endMs = new Date(endTime).getTime()
      if (Number.isNaN(startMs) || Number.isNaN(endMs) || endMs < startMs) {
        return '-'
      }
      const hours = (endMs - startMs) / (3600 * 1000)
      return hours.toFixed(2)
    },
    formatDateTime(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      const date = new Date(val)
      const year = date.getFullYear()
      const month = (`0${date.getMonth() + 1}`).slice(-2)
      const day = (`0${date.getDate()}`).slice(-2)
      const hour = (`0${date.getHours()}`).slice(-2)
      const minute = (`0${date.getMinutes()}`).slice(-2)
      const second = (`0${date.getSeconds()}`).slice(-2)
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-table {
  font-size: 13px;
}

.detail-apply-section {
  margin-top: 16px;
}
.detail-apply-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.detail-apply-empty {
  color: #909399;
  font-size: 13px;
  padding: 12px 0;
  text-align: center;
}
.detail-apply-master-table {
  width: 100%;
}
.detail-apply-expand-label {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 8px;
}
.detail-apply-inner-empty {
  color: #909399;
  font-size: 12px;
  padding: 8px 0;
}
.detail-photo-section {
  margin-top: 16px;
}
.detail-photo-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.detail-photo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.detail-photo {
  width: 112px;
  height: 112px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #f5f7fa;
}
.detail-photo-empty {
  height: 64px;
  line-height: 64px;
  text-align: center;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
</style>
